<template>
	<div class="xnd">
		<el-row>
			<el-col :span="8"><span style="color:transparent">占</span></el-col>
			<el-col :span="8">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{ p_name }}</span>
					</div>
					<el-form label-width="90px" size="mini">
						<el-form-item label="方案名称"><el-input v-model="percwinfo.c_name" @input="changeinput" type="text"></el-input></el-form-item>
					</el-form>
					<el-form label-width="90px" size="mini" :key="index" v-for="(payitem,index) in paylist">
						<el-form-item label="计费公式">
							<el-select v-model="payitem.unit" style="width:100%">
								<el-option  v-for="item in options"
      :key="item.label"
      :label="item.label"
      :value="item.label"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<el-form label-width="90px" size="mini">
						<el-form-item label="备  注"><el-input v-model="percwinfo.remark" @input="changeinput" type="textarea" row="5"></el-input></el-form-item>
						<el-form-item size="medium" style="padding-left:15%">
							<el-button type="success" @click="savepayrule" size="mini">保存</el-button>
							<el-button @click="rebacksetscheme" size="mini">返回</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
			<el-col :span="8"><span style="color:transparent"></span></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			unit: '',
			btndisabled: false,
			title: '鑫诺达',
			options: [],
			percwinfo: {
				c_name:'',
				c_id:'',
				remark:''
			},
			ischange: false,
			p_name:'',
			paylist:[{unit:''}]
		};
	},
	mounted() {},
	methods: {
		init(param) {
			var that=this;
			if (param != '' && param != undefined) {
				this.p_name = param.p_name;
				if (param.percwinfo != undefined) {
					if (param.percwinfo.c_id != undefined) this.percwinfo.c_id = param.percwinfo.c_id;
					if (param.percwinfo.c_name != undefined) this.percwinfo.c_name = param.percwinfo.c_name;
					if (param.percwinfo.remark != undefined) this.percwinfo.remark = param.percwinfo.remark;
					} else {
					(this.percwinfo ={c_name:'',
				remark:'',
				c_id:''})
						(this.paylist = []),
						(this.ischange = false);
				}
				this.isedit = param.isedit;
				this.$apipost.get.dic({ type: '鑫诺达计费公式' }).then(res => {
					that.options = res.data.list;
					that.paylist=[{unit:that.options[0].unit}];
					that.GetCurrentscheme();
				});
			}
		},
		GetCurrentscheme() {
			var that = this;			
			if (this.percwinfo.c_id != '' && this.percwinfo.c_id != undefined) {
				var paraminfo = {
					c_id: this.percwinfo.c_id,
					ismain: 0
				};
				this.$apipost.get.Getscheme({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if (res.paylist != undefined) {
							if(res.paylist.length>0)
								that.paylist = res.paylist;
						} else {
							this.$tool.message('读取方案失败，请重新打开', 0);
						}
					}
				});
			}
			
		},
		
		//保存提成比例
		savepayrule() {
			var that = this;
			if (this.percwinfo.c_name == '') {
				this.$tool.message('请输入方案名称', 0);
				return false;
			}
			var paylist =JSON.parse(JSON.stringify(this.paylist));
			paylist.forEach(e=>{
				e.c_id=that.percwinfo.c_id;
				e.c_name=that.percwinfo.c_name;
				e.remark=that.percwinfo.remark;
				e.p_type="鑫诺达";
				e.userid=localStorage.getItem('userid');
			});
			this.$tool.loading('正在保存', 'xnd');
			this.$apipost.post.Savescheme({ paraminfo: paylist }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					setTimeout(function() {
						that.rebacksetscheme();
					}, 1500);
				} else this.$tool.message(res.message, 0);
			});
		},
		rebacksetscheme() {
			this.$emit('reback', {});
		},
		changeinput() {
			this.ischange = true;
		}
	}
};
</script>

